import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { API, UPLOADS } from "./../../config/api";
export default function Home() {
  const navigate = useNavigate();

  /* ================= STATES ================= */
  const [machines, setMachines] = useState([]);
  const [designers, setDesigners] = useState([]);
  const [workspace, setWorkspace] = useState([]);
  const [wishlist, setWishlist] = useState([]);
  const [user, setUser] = useState(null);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [designs, setDesigns] = useState([]);
  const [cartIds, setCartIds] = useState([]);
  const [wishlistIds, setWishlistIds] = useState([]);
  useEffect(() => {
    const loginUser = JSON.parse(sessionStorage.getItem("user"));
    if (loginUser) {
      const cart =
        JSON.parse(localStorage.getItem(`cart_${loginUser.id}`)) || [];
      const wishlist =
        JSON.parse(localStorage.getItem(`wishlist_${loginUser.id}`)) || [];

      setCartIds(cart.filter((i) => i.type === "design").map((i) => i.id));
      setWishlistIds(
        wishlist.filter((i) => i.type === "design").map((i) => i.id),
      );
    }
  }, []);
  const addToCart = (design) => {
    const user = JSON.parse(sessionStorage.getItem("user"));
    if (!user) return alert("Please Login First");

    let items = JSON.parse(localStorage.getItem(`cart_${user.id}`)) || [];
    const exists = items.find((i) => i.id === design.id && i.type === "design");

    if (exists) {
      items = items.filter((i) => !(i.id === design.id && i.type === "design"));
      setCartIds((prev) => prev.filter((id) => id !== design.id));
    } else {
      items.push({ ...design, type: "design" });
      setCartIds((prev) => [...prev, design.id]);
    }

    localStorage.setItem(`cart_${user.id}`, JSON.stringify(items));
    window.dispatchEvent(new Event("cartUpdated"));
  };
  const addToWishlist = (design) => {
    const user = JSON.parse(sessionStorage.getItem("user"));
    if (!user) return;

    let items = JSON.parse(localStorage.getItem(`wishlist_${user.id}`)) || [];
    const exists = items.find((i) => i.id === design.id && i.type === "design");

    if (exists) {
      items = items.filter((i) => !(i.id === design.id && i.type === "design"));
      setWishlistIds((prev) => prev.filter((id) => id !== design.id));
    } else {
      items.push({ ...design, type: "design" });
      setWishlistIds((prev) => [...prev, design.id]);
    }

    localStorage.setItem(`wishlist_${user.id}`, JSON.stringify(items));
    window.dispatchEvent(new Event("cartUpdated"));
  };
  const fetchAllData = useCallback(async () => {
    const timestamp = new Date().getTime();

    try {
      // Machines
      const resM = await fetch(`${API.LIST_ACTIVE_MACHINES}&t=${timestamp}`);
      const dataM = await resM.json();
      setMachines(Array.isArray(dataM) ? dataM : dataM.data || []);

      // Designers
      const resD = await fetch(`${API.LIST_ACTIVE_DESIGNERS}&t=${timestamp}`);
      const dataD = await resD.json();
      setDesigners(Array.isArray(dataD) ? dataD : dataD.data || []);

      // Workspaces
      const resW = await fetch(`${API.LIST_ACTIVE_WORKSPACES}&t=${timestamp}`);
      const dataW = await resW.json();
      setWorkspace(Array.isArray(dataW) ? dataW : dataW.data || []);

      // Designs
      const resDesign = await fetch(`${API.LIST_DESIGNS}&t=${timestamp}`);
      const dataDesign = await resDesign.json();
      setDesigns(dataDesign.data || []);
    } catch (error) {
      console.log("Fetch Error:", error);
    }
  }, []);

  useEffect(() => {
    fetchAllData();
    const interval = setInterval(fetchAllData, 5000); // Auto-update every 5 seconds
    window.addEventListener("focus", fetchAllData);

    return () => {
      clearInterval(interval);
      window.removeEventListener("focus", fetchAllData);
    };
  }, [fetchAllData]);

  /* ================= WISHLIST LOGIC ================= */
  const loadUserAndWishlist = useCallback(() => {
    const loginUser = JSON.parse(sessionStorage.getItem("user"));
    setUser(loginUser);
    if (loginUser) {
      const saved =
        JSON.parse(localStorage.getItem(`wishlist_${loginUser.id}`)) || [];
      setWishlist(saved);
    } else {
      setWishlist([]);
    }
  }, []);

  useEffect(() => {
    loadUserAndWishlist();
    window.addEventListener("wishlistUpdate", loadUserAndWishlist);
    window.addEventListener("storage", loadUserAndWishlist);
    return () => {
      window.removeEventListener("wishlistUpdate", loadUserAndWishlist);
      window.removeEventListener("storage", loadUserAndWishlist);
    };
  }, [loadUserAndWishlist]);

  useEffect(() => {
    loadUserAndWishlist();

    // 🔥 CHANGE THIS: Listen for the universal "cartUpdated" event
    window.addEventListener("cartUpdated", loadUserAndWishlist);
    window.addEventListener("storage", loadUserAndWishlist);

    return () => {
      window.removeEventListener("cartUpdated", loadUserAndWishlist);
      window.removeEventListener("storage", loadUserAndWishlist);
    };
  }, [loadUserAndWishlist]);
  const isLiked = (id, type) =>
    wishlist.some((w) => w.id === id && w.type === type);

  /* ================= HERO SLIDER ================= */
  const slides = [
    {
      img: "/img/1.webp",
      title: "Buy Embroidery Machines",
      subtitle: "Best Quality Machines for Business",
      btn: "Shop Now",
      link: "/machine",
    },
    {
      img: "/img/2.webp",
      title: "Rent Workspace",
      subtitle: "Affordable Workrooms in Surat",
      btn: "Explore Rooms",
      link: "/house",
    },
    {
      img: "/img/2.webp",
      title: "Hire Designers",
      subtitle: "Find Skilled Embroidery Experts",
      btn: "Hire Now",
      link: "/designer",
    },
  ];

  useEffect(() => {
    const slideInterval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 4000);
    return () => clearInterval(slideInterval);
  }, [slides.length]);
  const toggleWishlist = (item, type) => {
    if (!user) {
      alert("Please login first");
      return;
    }
    const storageKey = `wishlist_${user.id}`;
    let updated = JSON.parse(localStorage.getItem(storageKey)) || [];

    const exists = updated.find((i) => i.id === item.id && i.type === type);
    if (exists) {
      updated = updated.filter((i) => !(i.id === item.id && i.type === type));
    } else {
      updated.push({ ...item, type: type });
    }

    localStorage.setItem(storageKey, JSON.stringify(updated));
    setWishlist(updated);

    // 🔥 CHANGE THIS: Notify Navbar and other pages using the universal name
    window.dispatchEvent(new Event("cartUpdated"));
  };
  return (
    <>
      {/* HERO SLIDER */}
      <div className="hero-slider">
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`hero-slide ${index === currentSlide ? "active" : ""}`}
            style={{ backgroundImage: `url(${slide.img})` }}
          >
            <div className="hero-overlay">
              <h1>{slide.title}</h1>
              <p>{slide.subtitle}</p>
              <button onClick={() => navigate(slide.link)}>{slide.btn}</button>
            </div>
          </div>
        ))}
        <div className="hero-dots">
          {slides.map((_, i) => (
            <span
              key={i}
              className={i === currentSlide ? "active-dot" : ""}
              onClick={() => setCurrentSlide(i)}
            ></span>
          ))}
        </div>
      </div>

      <div className="home-page container-fluid py-4">
        <div className="row g-4">
          <div className="col-lg-9 col-md-8 col-12">
            {/* ABOUT & WHY US (Static Content) */}
            <div className="about-section mb-4">
              <h2>Who We Are</h2>
              <p>
                StitchMart is a one-stop platform where you can buy embroidery
                machines, rent workspace, and hire skilled designers.
              </p>
            </div>

            <div className="about-section mb-5">
              <h2>Why Choose Us</h2>
              <div className="why-grid">
                <div>
                  <i className="bi bi-award"></i>
                  <h5>Best Quality</h5>
                  <p>Verified listings</p>
                </div>
                <div>
                  <i className="bi bi-currency-rupee"></i>
                  <h5>Affordable</h5>
                  <p>Best market prices</p>
                </div>
                <div>
                  <i className="bi bi-people"></i>
                  <h5>Expert Network</h5>
                  <p>Skilled designers</p>
                </div>
                <div>
                  <i className="bi bi-headset"></i>
                  <h5>Support</h5>
                  <p>24/7 help</p>
                </div>
              </div>
            </div>
            <div className="container-section mb-5">
              <h2 className="section-title">New Designs</h2>

              <div className="designs-grid">
                {designs.slice(0, 4).map((design) => (
                  <div
                    className="design-card"
                    key={design.id}
                    onClick={() =>
                      navigate(`/designe-details/${design.id}`, {
                        state: design,
                      })
                    }
                  >
                    <div className="image-wrapper">
                      <img
                        src={`${UPLOADS.DESIGN_IMAGE}${design.jpeg_file}`}
                        alt={design.design_code}
                      />
                    </div>

                    <div className="card-body">
                      <div className="design-specs">
                        <div className="spec-left">
                          <div>
                            <strong>Stitch:</strong> {design.stitch}
                          </div>
                          <div>
                            <strong>Colour:</strong> {design.color}
                          </div>
                        </div>

                        <div className="spec-right">
                          <div>
                            <strong>Area:</strong> {design.area}
                          </div>
                          <div>
                            <strong>Code:</strong> {design.design_code}
                          </div>
                        </div>
                      </div>

                      <h5 className="price-tag-row text-center">₹ 0</h5>

                      <div className="card-action-row">
                        <div className="action-btns">
                          <button
                            className={`select-btn ${cartIds.includes(design.id) ? "selected-btn" : ""}`}
                            onClick={(e) => {
                              e.stopPropagation();
                              addToCart(design);
                            }}
                          >
                            <i
                              className={`bi ${
                                cartIds.includes(design.id)
                                  ? "bi-cart-check-fill"
                                  : "bi-cart-fill"
                              } me-1`}
                            ></i>

                            {cartIds.includes(design.id)
                              ? "SELECTED"
                              : "SELECT DESIGN"}
                          </button>

                          <button
                            className="wish-btn"
                            onClick={(e) => {
                              e.stopPropagation();
                              addToWishlist(design);
                            }}
                          >
                            <i
                              className={`bi ${
                                wishlistIds.includes(design.id)
                                  ? "bi-heart-fill text-danger"
                                  : "bi-heart"
                              }`}
                            ></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="text-center mt-4">
                <button
                  className="view-more-btn"
                  onClick={() => navigate("/designes")}
                >
                  View More Designs
                  <i className="bi bi-arrow-right ms-2"></i>
                </button>
              </div>
            </div>

            {/* FEATURED MACHINES */}
            <div className="container-section mb-5">
              <h2 className="section-title">Featured Machines</h2>
              <div className="designs-grid">
                {machines.slice(0, 3).map((item) => {
                  const images = item.image ? item.image.split(",") : [];
                  return (
                    <div className="design-card shadow-sm" key={item.id}>
                      <div className="machine-img-container">
                        <img
                          src={`${UPLOADS.MACHINE_IMAGE}${images[0]}`}
                          alt={item.machine_name}
                        />
                        <span className="heads-badge">
                          {item.NoOfHeads || "Multi"} Heads
                        </span>
                      </div>

                      <div className="machine-body">
                        <div className="machine-type">
                          <h4 className="machine-name">{item.machine_name}</h4>
                        </div>
                        <div className="d-flex align-items-center justify-content-between mt-2">
                          <div className="price-block">
                            <span className="currency-symbol">₹</span>
                            <span className="amount">
                              {Number(item.price).toLocaleString("en-IN")}
                            </span>
                          </div>
                          <button
                            className="contact-btn"
                            onClick={() =>
                              navigate(`/productdetails/${item.id}`)
                            }
                          >
                            <i className="bi bi-telephone-fill me-1"></i>{" "}
                            Contact
                          </button>
                        </div>
                        <div className="spec-row mt-2">
                          <div className="spec-item">
                            <span className="spec-label">Brand:</span>
                            <span className="spec-value">{item.brand}</span>
                          </div>
                          <div className="spec-item">
                            <span className="spec-label">Model:</span>
                            <span className="spec-value">{item.model}</span>
                          </div>
                        </div>
                        <div className="location-info">
                          <i className="bi bi-geo-alt-fill"></i> {item.city},{" "}
                          {item.state}
                        </div>

                        <div className="machine-footer mt-1">
                          <button
                            className="more-details-btn"
                            onClick={() =>
                              navigate(`/productdetails/${item.id}`)
                            }
                          >
                            <i className="bi bi-info-circle me-2"></i>
                            More Details
                          </button>

                          <button
                            className="footer-like-btn"
                            onClick={() => toggleWishlist(item, "machine")}
                          >
                            <i
                              className={`bi ${isLiked(item.id, "machine") ? "bi-heart-fill text-danger" : "bi-heart"}`}
                            ></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
              <div className="text-center mt-4">
                <button
                  className="view-more-btn"
                  onClick={() => navigate("/machine")}
                >
                  View More Machines
                  <i className="bi bi-arrow-right ms-2"></i>
                </button>
              </div>
            </div>

            {/* FEATURED DESIGNERS */}
            <div className="container-section mb-5">
              <h2 className="section-title">Expert Designers</h2>
              <div className="designs-grid">
                {designers.slice(0, 3).map((item) => (
                  <div className="design-card shadow-sm" key={item.id}>
                    <div className="machine-img-container">
                      <img
                        src={`${UPLOADS.DESIGNER_IMAGE}${item.profile}`}
                        alt={item.name}
                      />
                    </div>
                    <div className="machine-body">
                      <h4 className="machine-name">{item.name}</h4>
                      <div className="d-flex align-items-center justify-content-between mt-2">
                        <div className="price-block">
                          <span className="currency-symbol">₹</span>
                          <span className="amount">{item.expected_salary}</span>
                          <span className="text-muted small"> / hour</span>
                        </div>
                        <button
                          className="contact-btn"
                          onClick={() =>
                            navigate(`/designerdetails/${item.id}`)
                          }
                        >
                          <i className="bi bi-telephone-fill me-1"></i> Contact
                        </button>
                      </div>
                      <div className="spec-row mt-3">
                        <div className="spec-item">
                          <span className="spec-label">Skills:</span>
                          <span className="spec-value">{item.skills}</span>
                        </div>

                        <div className="spec-item">
                          <span className="spec-label">Exp:</span>
                          <span className="spec-value">{item.experience}</span>
                        </div>
                      </div>
                      <div className="location-info">
                        <i className="bi bi-geo-alt-fill"></i> {item.location}
                      </div>

                      <div className="machine-footer mt-1">
                        <button
                          className="more-details-btn"
                          onClick={() =>
                            navigate(`/designerdetails/${item.id}`)
                          }
                        >
                          <i className="bi bi-person-badge-fill me-2"></i>
                          Hire Now
                        </button>

                        <button
                          className="footer-like-btn"
                          onClick={() => toggleWishlist(item, "designer")}
                        >
                          <i
                            className={`bi ${isLiked(item.id, "designer") ? "bi-heart-fill text-danger" : "bi-heart"}`}
                          ></i>
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="text-center mt-4">
                <button
                  className="view-more-btn"
                  onClick={() => navigate("/designer")}
                >
                  View More Designers
                  <i className="bi bi-arrow-right ms-2"></i>
                </button>
              </div>
            </div>

            {/* FEATURED WORKSPACES */}
            <div className="container-section">
              <h2 className="section-title">Workspaces</h2>
              <div className="designs-grid">
                {workspace.slice(0, 3).map((item) => {
                  const images = item.image ? item.image.split(",") : [];
                  return (
                    <div className="design-card shadow-sm" key={item.id}>
                      <div className="machine-img-container">
                        <img
                          src={`${UPLOADS.WORKSPACE_IMAGE}${images[0]}`}
                          alt="workspace"
                        />
                      </div>
                      <div className="machine-body">
                        <h4 className="machine-name">{item.location}</h4>
                        <div className="d-flex align-items-center justify-content-between mt-2">
                          <div className="price-block">
                            <span className="currency-symbol">₹</span>
                            <span className="amount">
                              {parseInt(item.rent_price).toLocaleString(
                                "en-IN",
                              )}
                            </span>
                            <span className="rent-unit"> / mo</span>
                          </div>
                          <button
                            className="contact-btn"
                            onClick={() =>
                              navigate(`/houserentDetails/${item.id}`)
                            }
                          >
                            <i className="bi bi-telephone-fill me-1"></i>{" "}
                            Contact
                          </button>
                        </div>

                        <div className="spec-row mt-2">
                          <div className="spec-item">
                            <span className="spec-label">Size:</span>
                            <span className="spec-value"> {item.size} </span>
                          </div>
                          <div className="spec-item">
                            <span className="spec-label">Floor:</span>
                            <span className="spec-value"> {item.floor}</span>
                          </div>
                        </div>

                        <div className="location-info mt-2">
                          <i className="bi bi-geo-alt-fill"></i> {item.city} ,
                          {item.state}
                        </div>

                        <div className="machine-footer mt-1">
                          <button
                            className="more-details-btn"
                            onClick={() =>
                              navigate(`/houserentDetails/${item.id}`)
                            }
                          >
                            <i className="bi bi-info-circle me-2"></i> View
                            Details
                          </button>

                          <button
                            className="footer-like-btn"
                            onClick={() => toggleWishlist(item, "house")}
                          >
                            <i
                              className={`bi ${isLiked(item.id, "house") ? "bi-heart-fill text-danger" : "bi-heart"}`}
                            ></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
              <div className="text-center mt-4">
                <button
                  className="view-more-btn"
                  onClick={() => navigate("/house")}
                >
                  View More workplace
                  <i className="bi bi-arrow-right ms-2"></i>
                </button>
              </div>
            </div>
          </div>
          <div className="d-lg-none mt-4">
            <div className="mobile-ads p-3 bg-white shadow-sm rounded text-center">
              <h6 className="fw-bold">Sponsored</h6>

              <div className="ad-card mt-2">
                <div className="ad-placeholder">
                  <p className="small text-muted">Your Ad Here</p>
                </div>
                <p className="small mt-2">Premium Threads Sale!</p>
              </div>
            </div>
          </div>
          {/* ADS SIDEBAR */}
          <div className="col-lg-3 col-md-4 col-12">
            <div className="ads-sidebar p-3 bg-white shadow-sm rounded text-center">
              <h5 className="ads-title">Sponsored</h5>

              <div className="ad-card mt-3">
                <div className="ad-placeholder">
                  <p className="small text-muted">Your Ad Here</p>
                </div>

                <p className="small mt-2">Premium Threads Sale!</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
